import { MatDialog } from '@angular/material';
import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { AppModule } from './../app.module';
import { AppConfig } from './../config/app.config';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProjectDataService } from './../services/project-data.service';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProjectData } from '../models/project-data.model';
import { AuthenticationService } from '../services/authentication.service';
import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MSAL_INTERCEPTOR_CONFIG, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-common';
import { ConfigService } from '../services/config.service';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  error = "";
  model: any = {};
  loggingIn: boolean;
  loginStartTime: number;

  supportEmailRedirect: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private projectDataService: ProjectDataService,
    private authService: AuthenticationService,
    private environment: AppConfig,
    private dialog: MatDialog,
    private config: ConfigService
  ) {}

  ngOnInit() {
    function loggerCallback(logLevel: LogLevel, message: string) {
      console.log("MSAL Angular: ", message);
    }
        
    this.authService.signIn().subscribe({
      next: (result : any) => {
        if (result) {
          let userInfo = JSON.stringify(result);
          sessionStorage.setItem('userInfo', userInfo);
          localStorage.setItem('userInfo', userInfo);
          this.oauthLogin();
        }
        else {
          // refine error state
        }
      },
      error: (error) => console.log(error)
    });
  }

  oauthLogin() {
    this.authService.login().subscribe(() => {
      this.login();
    }, error => {
      console.log('error', error);
      let errorType = '';
      let errorDescription = '';
      if (error.error.error) {
        errorDescription = errorDescription.concat('Login Error - ', error.error.message);
        errorType = errorType.concat(error.error.status, ' ', error.error.error);
      }
      else {
        errorDescription = errorDescription.concat('Login Error');
        errorType = errorType.concat(error.status, ' ', error.statusText)
      }
      let dataStructure = {
        errorType: errorType,
        errorDescription: errorDescription
      };
      this.dialog.open(ErrorDialogComponent, {
        data: dataStructure,
        disableClose: true
      });
    });
  }

  login() {
    // entryURL may be in sessionStorage (set by signOut or restored from localStorage)
    // or still only in localStorage if sessionStorage was wiped by a MSAL full-page redirect.
    const entryURL = sessionStorage.getItem('entryURL') || localStorage.getItem('entryURL');
    if (entryURL && (entryURL.includes('?guid') || entryURL.includes('&guid'))) {
      // Clear the saved entry URL so it doesn't affect future logins.
      sessionStorage.removeItem('entryURL');
      localStorage.removeItem('entryURL');
      this.router.navigateByUrl(entryURL.slice(this.config.getConfig('RedirectUri').length));
    }
    else {
      this.initializeProjectData();
      this.router.navigate(["/dashboard"]);
    }
  }

  initializeProjectData() {
    this.projectDataService.projectData = new ProjectData();
  }

  clearError() {
    this.error = "";
  }
}
